<br>
<div class="card card-default">
    <div class="card-header title_size">
    <h2 class="card-title">Edit Brand Details</h2>
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    
    <div class="card-body">

    <div class="row">
    <div class="col-md-6">

      
        <div class="form-group">
            <label>Brand Name</label>
            <input type="text" class="form-control"  name="code" [(ngModel)]="data.brand_name">
        </div>
        <div class="form-group">
            <label>Brand Code</label>
            <input type="text" class="form-control"  name="role" [(ngModel)]="data.brand_code">
        </div>
        <div class="form-group">
            <label>Brand Manager</label>
                <div class="input-group">
                    <input type="search" class="form-control form-control-lg" placeholder="Search employee" [(ngModel)]="data.brand_manager_name" (ngModelChange)="SearchEmployee();">
                    <button type="submit" class="btn btn-lg btn-default" (click)="SearchEmployee();">
                    <i class="fa fa-search"></i>
                    </button>
                    </div>
                   
                        <div class="card card-default"  *ngIf="isShownEmployee">
                        <div *ngFor="let c of employee" >
                        <h4 class="font" (click)="getEmployeeId(c.employee_id,c.employee_name)"><b>{{c.employee_name}}</b></h4>
                        </div>
                        </div> 
                  
                </div>

    </div>

    <!---------------------------------------------next row-------------------------------------->
    <div class="col-md-6">

            <div class="form-group">
                <label>Brand Id</label>
                <input type="text"  [readonly]="true" class="form-control"  name="name" [(ngModel)]="data.brand_id">
            </div>
 
        

        <div class="form-group">
            <label>Image</label>
            <input type="search" class="form-control"  name="role" [(ngModel)]="name" (change)="RemoveFile()">
        </div>

     
            <div class="form-group">
                <div class="custom-file">
                    <input #imageInput type="file" class="custom-file-input" id="customFile" accept="image/*" (change)="processFile(imageInput)">
                    <label class="custom-file-label" for="customFile">{{ImageName}}</label>
                </div>
            </div>
        </div>
        
        <!---------------------------------------------------------->
        </div>
        
        <div class="alert alert-success alert-dismissible alertWidth" *ngIf="isShown">
            <button type="button" class="close" data-dismiss="alert" aria-hidden="true" (click)="shown()">×</button>
            <h4><i class="icon fas fa-check"></i> {{alert}}</h4>    
        </div>
        
        <button type="submit" class="btn btn-primary btn_allign" (click)="btnClick(); notification();">Submit</button>

    </div>
    </div>